module.exports = __webpack_public_path__ + "media/images/Marca-925ac7cab64e5521b9e97c1bf7c6b355.png";